import { authHeader } from '../Helpers';
import { endpoints } from '../Constants';
import handleResponse from './helpers';

// Backs the Lane Planning board (Pages/LanePlanning). Talks to LaneController
// in uy-qc-report-service (proxied through DASHBOARD_BASE_URL, same as the
// AssetType/OEM services).
function postJson(url, data) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(data || {}),
	};
	return fetch(url, requestOptions).then(handleResponse);
}

// Lane types (LaneController / LaneType). PACKING is the original lane; the
// server reads a missing laneType as PACKING.
export const LANE_TYPES = {
	PACKING: 'PACKING',
	STORAGE: 'STORAGE',
};

function fetchLanes(laneType = LANE_TYPES.PACKING) {
	return postJson(endpoints.LANE_LIST, {
		laneType,
	});
}

// Server-side gated to INTERNAL/MANAGER users - see LaneController#canManageLanes.
function createLane(name, laneType = LANE_TYPES.PACKING) {
	return postJson(endpoints.LANE_CREATE, {
		name,
		laneType,
	});
}

// Soft delete; the server also moves the lane's orders back to unassigned.
// The lane's own type decides which assignments are cleared.
// Gated to INTERNAL/MANAGER users like createLane.
function deleteLane(laneId) {
	return postJson(endpoints.LANE_DELETE, {
		laneId,
	});
}

// The lane's own type decides whether this sets the order's packing or storage lane.
function assignLane(poId, laneId) {
	return postJson(endpoints.LANE_ASSIGN, {
		poId,
		laneId,
	});
}

function unassignLane(poId, laneType = LANE_TYPES.PACKING) {
	return postJson(endpoints.LANE_UNASSIGN, {
		poId,
		laneType,
	});
}

function fetchLaneAssignments(laneType = LANE_TYPES.PACKING) {
	return postJson(endpoints.LANE_ASSIGNMENTS, {
		laneType,
	});
}

const laneServices = {
	fetchLanes,
	createLane,
	deleteLane,
	assignLane,
	unassignLane,
	fetchLaneAssignments,
};

export default laneServices;
